export const PERFORMANCE_REPORT_BUILDER_PAGE_NS = 'pages/PerformanceReportBuilderPage';

export const i18n = {
  en: {
    buttons: {
      publish: 'Publish',
      retryAll: 'Retry all',
      resetChanges: 'Reset Changes',
    },
    labels: {
      saving: 'Saving',
      savingError: 'Saving Error',
      publishError: 'Publish Error',
      resetChangesError: 'Reset Changes Error',
      noComponentsYet: 'No components yet',
    },
    tooltips: {
      settings: 'Settings',
      advancedEditor: 'Advanced Editor',
      resetToLastPublishedVersion: 'Reset to the last published version',
    },
    placeholders: {
      untitledDashboard: 'Untitled dashboard',
    },
    descriptions: {
      unpublishedChangesWillNotBeSaved: 'Any unpublished changes will not be saved.',
    },
    prompts: {
      areYouSureToResetDashboard:
        'Are you sure you want to reset dashboard to its last published version?',
    },
    errors: {
      dashboardNameIsRequired: 'Dashboard name can not be empty',
    },
  },
};
